<template>
  <div class="main_right">
    <breadcrumb :breadcrumb="config.breadcrumb" />
    <text-title :mainTitle="mainTitle" :subheading="subheading" />
    <form>
      <div class="form-line">
        <div class="textBox">
          <b class="red">*</b>
          <span class="line-text">设备名称：</span>
        </div>
        <el-input v-model="name" size="small" style="width: 280px" />
        <span v-html="nameVer"></span>
      </div>

      <div class="form-line">
        <div class="textBox">
          <b class="red">*</b>
          <span class="line-text">设备编号：</span>
        </div>
        <el-input v-model="deviceCode" size="small" style="width: 280px" />
      </div>

      <div class="form-line">
        <div class="textBox">
          <b class="red">*</b>
          <span class="line-text">设备厂家：</span>
        </div>
        <el-select v-model="deviceManufacturerCode" size="small" style="width: 280px">
          <el-option v-for="item in deviceManufacturerList" :key="item.code"
                     :label="item.name" :value="item.code">
          </el-option>
        </el-select>
      </div>

      <div class="form-line">
        <div class="textBox">
          <b class="red">*</b>
          <span class="line-text">设备型号：</span>
        </div>
        <el-select v-model="deviceModelCode" size="small" style="width: 280px">
          <el-option v-for="item in deviceModelNameList" :key="item.code"
                     :label="item.name" :value="item.code">
          </el-option>
        </el-select>
      </div>

      <div class="form-line">
        <div class="textBox">
          <span class="line-text">所属楼栋：</span>
        </div>
        <el-select v-model="buildingCode" size="small" style="width: 280px">
          <el-option v-for="item in buildingList" :key="item.code"
                     :label="item.name" :value="item.code">
          </el-option>
        </el-select>
      </div>

      <div class="form-line">
        <div class="textBox">
          <span class="line-text">设备位置：</span>
        </div>
        <el-input v-model="location" size="small" style="width: 280px" />
      </div>


      <!--<div class="form-line">-->
        <!--<div class="textBox">-->
          <!--<b class="red">*</b>-->
          <!--<span class="line-text">设备所在房间：</span>-->
        <!--</div>-->
        <!--<input-tree :fetch="fetchDetail" :showCheckBox="true" @chooseLine="getRoomList" :theValue="roomCode" :theName="roomNumber" style="width: 280px" />-->
      <!--</div>-->


      <div class="form-line">
        <div class="textBox">
          <span class="line-text">责任人：</span>
        </div>
        <el-select v-model="responsiblePersonCode"
                   filterable
                   remote
                   reserve-keyword
                   size="small" style="width: 280px"
                   :remote-method="remoteMethod"
                   placeholder="请输入关键词查询">
          <el-option v-for="item in responsiblePersonList" :key="item._value"
                     :label="item._label" :value="item._value">
          </el-option>
        </el-select>
        <span v-html="responsiblePersonVer"></span>
      </div>

      <div class="form-btn-box">
        <button-confirm @confirm="add" />
        <button-confirm-next @confirm="addNext" value="添加下一项" />
        <button-cancel @cancel="strategyCenter" />
      </div>

    </form>
  </div>
</template>

<script>
  import BreadCrumb from '../../../components/common/di-ding/common/bread-crumb'
  import {errorHandler} from '../../../utils/errorHandler'
  import InputTree from '../../../components/common/inputs/input-tree'
  import {pattern} from '../../../utils/regular'
  import {api} from '../../api/WaterManagement'
  import Breadcrumb from '../../../components/Breadcrumb/Breadcrumb'
  import TextTitle from '../../../components/Text/TextTitle'
  import ButtonCancel from '../../../components/Button/ButtonCancel'
  import ButtonConfirm from '../../../components/Button/ButtonConfirm'
  import {nError, nSuccess} from '../../../utils/notice'
  import ButtonConfirmNext from '../../../components/Button/ButtonConfirmNext'
  import {treeApi} from '../../api/TreeApi'
  // let a = document.getElementsByClassName()

  export default {
    components: {
      ButtonConfirmNext,
      ButtonConfirm,
      ButtonCancel,
      TextTitle,
      Breadcrumb,
      InputTree,
      BreadCrumb
    },
    name: 'controller-add',
    data () {
      return {
        config: {
          breadcrumb: [{
            value: '智慧用水',
            name: 'water-over-view'
          }, {
            value: '集中器管理'
          }],
        },
        mainTitle: '添加集中器',
        subheading: '',
        name: '',
        deviceCode: '',
        nameVer: '<span>不超过32个字</span>',
        deviceManufacturerCode: '大麦物联',
        deviceManufacturerList: [
          {
            name: '大麦物联',
            code: '大麦物联'
          }
        ],
        deviceModelCode: 'DM-IOTC-WC',
        deviceModelNameList: [
          {
            name: 'DM-IOTC-WC',
            code: 'DM-IOTC-WC'
          }
        ],
        responsiblePersonCode: '',
        responsiblePersonList: [],
        responsiblePersonVer: '<span>责任人可接收设备离线通知</span>',
        buildingList: [],
        buildingName: '',
        buildingCode: '',
        nameHttp: false,
        deviceCodeHttp: false,
        fetchDetail: null,
        location: '',
      }
    },
    created () {
      this.getBuildingList()
      this.getResponsiblePersonList()

      // this.getAlldeviceManufacturer()
      // this.getAllDeviceType()
      // this.fetchDetail = () => {
      //   let treeList = []
      //   let yqCode = ''
      //
      //   return treeApi.getYqInfo()
      //     .then(yqData => {
      //       let yqObj = {}
      //       yqCode = yqData.yqCode
      //       yqObj._value = yqData.yqCode
      //       yqObj._label = yqData.yqName
      //       yqObj.parentCode = '0'
      //       yqObj.level = 1
      //       yqObj.code = yqData.yqCode
      //       treeList.push(yqObj)
      //
      //       treeApi.getVacancyRoomInfo(this.currentCode)
      //         .then(roomList => {
      //           roomList.map(room => {
      //             let roomObj = {}
      //             roomObj.buildingName = room.buildingName
      //             roomObj._value = room.code
      //             roomObj._label = room.roomNumber
      //             roomObj.parentCode = room.floorCode
      //             roomObj.level = 4
      //             roomObj.code = room.code
      //             roomObj.roomArea = room.roomArea
      //             roomObj.roomRent = room.roomRent
      //             roomObj.roomType = room.roomType
      //             treeList.push(roomObj)
      //           })
      //         })
      //
      //       treeApi.getBuildingList()
      //         .then(buildingList => {
      //           buildingList.map(v => {
      //             let obj = {}
      //             obj._value = v.code
      //             obj._label = v.name
      //             obj.parentCode = yqCode
      //             obj.level = 2
      //             obj.code = v.code
      //             treeList.push(obj)
      //             if (v.floors.length > 0) {
      //               v.floors.map(floor => {
      //                 let floorObj = {}
      //                 floorObj._value = floor.code
      //                 floorObj._label = floor.name
      //                 floorObj.parentCode = floor.buildingCode
      //                 floorObj.level = 3
      //                 floorObj.code = floor.code
      //                 treeList.push(floorObj)
      //               })
      //             }
      //           })
      //
      //         })
      //       return treeList
      //     })
      // }
    },
    methods: {
      // 获取责任人列表
      getResponsiblePersonList (searchKey) {
        this.$axios.post(api.getResponsiblePersonList, {
          searchKey: searchKey || ''
        })
          .then(res => {
            let list = res.data.data
            list.forEach(it => {
              it._value = it.code
              it._label = `${it.name} / ${it.phone}`
            })
            this.responsiblePersonList = list
          })
          .catch(errorHandler('获取责任人列表失败'))
      },
      getAlldeviceManufacturer () {
        this.$axios.post(api.getAllDeviceManufacture, {
          moduleCode: '2',
        })
          .then(res => {
            if (res.data.retCode === 1) {
              let data = res.data.data
              this.deviceManufacturerList = data
              if (this.deviceManufacturerList.length > 0) {
                this.deviceManufacturerCode = data[0].code
                // this.getAllDeviceType()
              }
            }
          })
          .catch(errorHandler('获取设备厂家失败'))
      },
      getAllDeviceType () {
        this.$axios.post(api.getAllDeviceType, {
          moduleCode: '2',
          deviceManufactureCode: this.deviceManufacturerCode
        })
          .then(res => {
            if (res.data.retCode === 1) {
              let data = res.data.data
              this.deviceModelNameList = data
              if (this.deviceModelNameList.length > 0) {
                this.deviceModelName = data[0].code
              }
            }
          })
          .catch(errorHandler('获取设备型号失败'))
      },

      // 获取楼栋列表
      getBuildingList () {
        this.$axios.post(api.getBuildingList, {})
          .then(res => {
            if (res.data.retCode === 1) {
              let data = res.data.data
              this.buildingList = data
            }
          })
          .catch(errorHandler('获取楼栋失败'))
      },

      remoteMethod (query) {
        this.getResponsiblePersonList(query)
      },
      // getRoomList (v) {
      //   this.roomCode = v.code
      //   this.roomNumber = v.buildingName + v._label
      // },
      addNext () {
        if (!this.name) {
          this.nameVer = '<span style="color: red;">请输入设备名称</span>'
          return false
        }
        if (!this.deviceCode) {
          nError('请输入设备编号')
          return false
        }
        if (!this.nameHttp) {
          return false
        } else {
          this.nameVer = '<span>不超过32个字</span>'
        }
        let obj = {
          name: this.name,
          deviceCode: this.deviceCode,
          deviceManufacturerCode: this.deviceManufacturerCode,
          deviceManufacturerName: '',
          deviceModelCode: this.deviceModelCode,
          deviceModelName: '',
          responsiblePersonCode: this.responsiblePersonCode,
          responsiblePersonName: '',
          responsiblePersonPhone: '',
          buildingName: '',
          buildingCode: this.buildingCode,
          location: this.location
        }
        this.deviceManufacturerList.map(v => {
          if (v.code === this.deviceManufacturerCode) {
            obj.deviceManufacturerName = v.name
          }
        })
        this.deviceModelNameList.map(v => {
          if (v.code === this.deviceModelCode) {
            obj.deviceModelName = v.name
          }
        })
        this.formData.responsiblePersonCode = this.responsiblePersonCode
        this.responsiblePersonList.map(v => {
          if (v.code === this.responsiblePersonCode) {
            obj.responsiblePersonName = v.name
            obj.responsiblePersonPhone = v.phone
          }
        })
        this.buildingList.map(v => {
          if (v.code === this.buildingCode) {
            obj.buildingName = v.name
          }
        })
        this.$axios.post(api.addwater, obj)
          .then(res => {
            if (res.data.retCode === 1) {
              nSuccess('添加成功')
              this.name = ''
              this.responsiblePersonCode = ''
            }
          })
          .catch(errorHandler('添加失败'))
      },
      add () {
        if (!this.name) {
          this.nameVer = '<span style="color: red;">请输入设备名称</span>'
          return false
        }
        if (!this.deviceCode) {
          nError('请输入设备编号')
          return false
        }
        if (!this.nameHttp) {
          return false
        } else {
          this.nameVer = '<span>不超过32个字</span>'
        }
        let obj = {
          name: this.name,
          deviceCode: this.deviceCode,
          deviceManufacturerCode: this.deviceManufacturerCode,
          deviceManufacturerName: '',
          deviceModelCode: this.deviceModelCode,
          deviceModelName: '',
          responsiblePersonCode: this.responsiblePersonCode,
          responsiblePersonName: '',
          responsiblePersonPhone: '',
          buildingName: '',
          buildingCode: this.buildingCode,
          location: this.location
        }
        this.deviceManufacturerList.map(v => {
          if (v.code === this.deviceManufacturerCode) {
            obj.deviceManufacturerName = v.name
          }
        })
        this.deviceModelNameList.map(v => {
          if (v.code === this.deviceModelCode) {
            obj.deviceModelName = v.name
          }
        })
        this.responsiblePersonList.map(v => {
          if (v.code === this.responsiblePersonCode) {
            obj.responsiblePersonName = v.name
            obj.responsiblePersonPhone = v.phone
          }
        })
        this.buildingList.map(v => {
          if (v.code === this.buildingCode) {
            obj.buildingName = v.name
          }
        })
        this.$axios.post(api.addWaterControlDevice, obj)
          .then(res => {
            if (res.data.retCode === 1) {
              nSuccess('添加成功')
              this.strategyCenter()
            }
          })
          .catch(errorHandler('添加失败'))
      },
      strategyCenter () {
        this.$router.push({
          name: 'water-controller-management'
        })
      }
    },
    watch: {
      name (v) {
        let ptn = pattern.basicAndCN.test(v)
        if (!ptn) {
          this.nameVer = '<span style="color: red;">只允许输入中文，字母，数字，下划线</span>'
          this.nameHttp = false
        } else {
          this.nameVer = '<span>不超过32个字</span>'
          this.nameHttp = true
        }
      },
      deviceManufacturerCode () {
        // this.getAllDeviceType()
      }
    }
  }
</script>

<style scoped>
  form {
    width: 90%;
    margin: 0 auto;
    text-align: left;
  }
  .red {
    color: #FF0000;
  }
  .form-line {
    margin: 20px 0;
  }
  .form-line>span {
    font-size: 12px;
    color: #97a8be;
  }
  .line-text{
    color: #48576a;
    font-size: 14px;
    margin-right: 10px;
  }
  .textBox {
    display: inline-block;
    width: 120px;
    text-align: right;
  }
  .form-btn-box {
    width: 530px;
    padding: 0 124px;
    margin-top: 40px;
    display: flex;
    justify-content: space-between;
  }
</style>



// WEBPACK FOOTER //
// src/view/WaterManage/ControllerManagement/ControllerAdd.vue